/*
 * Copyright (c) 2017-2026 Brighter AI Technologies GmbH. All rights reserved.
 * Unauthorized use, copying, reproduction, or distribution of this file, via any medium,
 * is strictly prohibited.
 */

import { AccountAndSettings } from "./AccountAndSettings";

export const profileRoute = {
  path: "/users/profile",
  key: "user-profile",
  component: AccountAndSettings,
};
